/**
 * @generated SignedSource<<6d181b722fb41e6ce6bd8bae4233cdb2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueLinkingProvider$data = {
  readonly jira: {
    readonly issueLinkTypes: {
      readonly totalCount: number | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "IssueLinkingProvider";
};
export type IssueLinkingProvider$key = {
  readonly " $data"?: IssueLinkingProvider$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueLinkingProvider">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "IssueLinkingProvider",
  "selections": [
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "cloudId",
              "variableName": "cloudId"
            }
          ],
          "concreteType": "JiraIssueLinkTypeConnection",
          "kind": "LinkedField",
          "name": "issueLinkTypes",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "totalCount"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "0f8950dfd0fbd65a5399fe1e0cd4f34c";

export default node;
